import React, { useState } from 'react';
import Overview from '../../components/Dashboard Admin/OverviewContent';
import Users from '../../components/Dashboard Admin/UsersContent';
import Courses from '../../components/Dashboard Admin/CourseContent';
import TrialClass from '../../components/Dashboard Admin/TrialClassContent';
import Assessment from '../../components/Dashboard Admin/AssessmentContent';
import CreateQuestion from '../../components/Dashboard Admin/CreateQuestionContent'; // <-- IMPORT BARU
import Feedback from '../../components/Dashboard Admin/FeedbackContent'; 

// --- CSS LAYOUT & GLOBAL ---
const layoutStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');

  :root {
      --primary-color: #e53935;
      --primary-light: #ff6f60;
      --primary-dark: #ab000d;
      --secondary-color: #f5f5f5;
      --text-dark: #2c3e50;
      --text-light: #7f8c8d;
      --border-color: #e0e0e0;
      --white: #ffffff;
      --card-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
      --gradient-primary: linear-gradient(135deg, #e53935 0%, #ff6f60 100%);
  }

  * { margin: 0; padding: 0; box-sizing: border-box; font-family: 'Inter', sans-serif; }
  body { background-color: #f8f9fa; color: var(--text-dark); min-height: 100vh; overflow-x: hidden; }

  /* Sidebar Styles */
  .mobile-header { display: none; background: var(--gradient-primary); color: white; padding: 15px 20px; align-items: center; justify-content: space-between; position: fixed; top: 0; left: 0; right: 0; z-index: 1000; }
  .menu-toggle { background: none; border: none; color: white; font-size: 24px; cursor: pointer; }
  
  .sidebar { width: 280px; background-color: var(--white); box-shadow: var(--card-shadow); display: flex; flex-direction: column; position: fixed; height: 100vh; z-index: 999; transition: transform 0.3s ease; left: 0; top: 0; }
  .sidebar.active { transform: translateX(0); }
  .logo { padding: 25px; text-align: center; background: var(--gradient-primary); color: white; }
  .logo h1 { font-size: 28px; font-weight: 800; letter-spacing: 1px; }
  .logo span { color: #ffccbc; }
  .logo p { font-size: 12px; opacity: 0.9; margin-top: 5px; }

  .menu { padding: 25px 0; flex-grow: 1; overflow-y: auto; } /* Added overflow-y for scrolling if many menus */
  .menu-item { padding: 18px 25px; display: flex; align-items: center; color: var(--text-dark); text-decoration: none; transition: all 0.3s ease; border-left: 5px solid transparent; margin-bottom: 5px; cursor: pointer; }
  .menu-item:hover { background-color: rgba(229, 57, 53, 0.05); color: var(--primary-color); }
  .menu-item.active { background-color: rgba(229, 57, 53, 0.1); color: var(--primary-color); border-left: 5px solid var(--primary-color); }
  .menu-item i { margin-right: 15px; font-size: 20px; width: 24px; text-align: center; }
  
  .logout { margin-top: auto; padding: 20px; border-top: 1px solid var(--border-color); }
  .logout-btn { display: flex; align-items: center; justify-content: center; padding: 14px; background: var(--gradient-primary); color: white; border: none; border-radius: 10px; font-weight: 600; cursor: pointer; width: 100%; }

  .main-content { flex-grow: 1; margin-left: 280px; padding: 30px; transition: margin-left 0.3s ease; }
  .header { display: flex; justify-content: space-between; align-items: center; padding: 20px 0; margin-bottom: 30px; }
  .header h2 { font-size: 32px; font-weight: 700; border-bottom: 4px solid var(--primary-color); display: inline-block; padding-bottom: 10px; }
  .sidebar-overlay { display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 998; }
  .sidebar-overlay.active { display: block; }

  @media (max-width: 992px) {
      .mobile-header { display: flex; }
      .sidebar { transform: translateX(-100%); }
      .sidebar.active { transform: translateX(0); }
      .main-content { margin-left: 0; padding: 20px; padding-top: 80px; }
  }
`;

const DashboardAdmin: React.FC = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Daftar Menu: Ditambahkan 'create-question'
  const menuItems = ['overview', 'users', 'courses', 'trial-class', 'assessment', 'create-question', 'feedback'];

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    if (window.innerWidth <= 992) setIsSidebarOpen(false);
  };

  const getIcon = (item: string) => {
    switch(item) {
      case 'overview': return 'chart-line';
      case 'users': return 'users';
      case 'courses': return 'graduation-cap';
      case 'trial-class': return 'calendar-check';
      case 'assessment': return 'clipboard-list';
      case 'create-question': return 'pen-to-square'; // Icon baru untuk Create Question
      case 'feedback': return 'comments';
      default: return 'circle';
    }
  };

  return (
    <>
      <style>{layoutStyles}</style>
      <div className="dashboard-wrapper">
        <div className="mobile-header">
          <button className="menu-toggle" onClick={() => setIsSidebarOpen(true)}><i className="fas fa-bars"></i></button>
          <h1>Fluen<span>esia</span></h1>
        </div>
        <div className={`sidebar-overlay ${isSidebarOpen ? 'active' : ''}`} onClick={() => setIsSidebarOpen(false)}></div>
        
        <div className={`sidebar ${isSidebarOpen ? 'active' : ''}`}>
          <div className="logo"><h1>Fluen<span>esia</span></h1><p>Admin Dashboard</p></div>
          <div className="menu">
            {menuItems.map((item) => (
              <div key={item} className={`menu-item ${activeTab === item ? 'active' : ''}`} onClick={() => handleTabChange(item)}>
                <i className={`fas fa-${getIcon(item)}`}></i>
                {/* Logic text replace sedikit diubah agar "Create Question" terlihat rapi */}
                <span>{item.charAt(0).toUpperCase() + item.slice(1).replace('-', ' ')}</span>
              </div>
            ))}
          </div>
          <div className="logout"><button className="logout-btn"><i className="fas fa-sign-out-alt"></i><span>Logout</span></button></div>
        </div>

        <div className="main-content">
          <div className="header">
            <h2>{activeTab.charAt(0).toUpperCase() + activeTab.slice(1).replace('-', ' ')}</h2>
          </div>
          {/* Render Komponen Berdasarkan Tab */}
          {activeTab === 'overview' && <Overview />}
          {activeTab === 'users' && <Users />}
          {activeTab === 'courses' && <Courses />}
          {activeTab === 'trial-class' && <TrialClass />}
          {activeTab === 'assessment' && <Assessment />}
          {activeTab === 'create-question' && <CreateQuestion />} {/* Render Komponen Baru */}
          {activeTab === 'feedback' && <Feedback />}
        </div>
      </div>
    </>
  );
};

export default DashboardAdmin;